// extracted by mini-css-extract-plugin
export default {"wrapper":"TextEditor_wrapper__rXN49","buttonsWrapper":"TextEditor_buttonsWrapper__Lc9eX"};